import { ErrorHandler, Injectable } from '@angular/core';

import type NewRelic from 'newrelic';
declare global {
  var newrelic: typeof NewRelic | undefined;
}

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  handleError(error: any): void {
    console.error(error);
    if (this.isError(error)) {
      globalThis.newrelic?.noticeError(error);
    } else {
      globalThis.newrelic?.noticeError(new Error(error.toString()));
    }
  }

  isError(error: any): error is Error {
    return error instanceof Error || Object.prototype.toString.call(error) === '[object Error]';
  }
}
